/**
 * @file select.component.tsx
 * @description Form-control обертка для работы с UI Select компонентом в react-hook-form
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, react-hook-form, @components/ui/base/select]
 * @related-files [@components/ui/base/select/select.tsx]
 */

import { Select as UISelect } from '@components/ui/base/select';
import { Controller, Control } from 'react-hook-form';

/**
 * Props для form-control компонента Select с интеграцией react-hook-form
 */
interface ISelect {
    /** Control объект из react-hook-form для управления формой */
    control: Control;
    /** Имя поля в форме */
    name: string;
    /** Лейбл поля */
    label?: string;
    /** Плейсхолдер для поля */
    placeholder?: string;
    /** CSS класс для стилизации */
    className?: string;
}

export const Select = ({ control, name, ...props }: ISelect) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <UISelect onChange={field.onChange} value={field.value} {...props} />
            )}
        />
    );
};
